<template>
    <AttachOperations></AttachOperations>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../../Layouts/AuthLayout.vue")
);
const AttachOperations = defineAsyncComponent(() =>
    import(
        "../../../components/ProjectManagement/HelpPage/EngineeringWorkbench/AttachOperations.vue"
    )
);

export default {
    name: "Project_HelpAttachOperations", //The name you are in should not equal the name of the component you are importing.
    components: { AttachOperations, AuthLayout },
};
</script>
